"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _phoneNumberPattern = _interopRequireDefault(require("../enums/phone-number-pattern"));
var _isPhoneNumber = _interopRequireDefault(require("./is-phone-number"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function formatPhoneNumber(phoneNumber) {
  if ((0, _isPhoneNumber.default)(phoneNumber)) {
    var ausNumber = phoneNumber.trim().replace(/\s/g, '');
    ausNumber = ausNumber.replace('+6113', '13');
    ausNumber = ausNumber.replace('+6118', '18');
    ausNumber = ausNumber.replace('+61', '0');
    if (ausNumber.match(_phoneNumberPattern.default.SMART_NUMBER_A)) {
      return "".concat(ausNumber.slice(0, 2), " ").concat(ausNumber.slice(2, 4), " ").concat(ausNumber.slice(4));
    }
    if (ausNumber.match(_phoneNumberPattern.default.SMART_NUMBER_B) || ausNumber.match(_phoneNumberPattern.default.SMART_NUMBER_C)) {
      return "".concat(ausNumber.slice(0, 4), " ").concat(ausNumber.slice(4, 7), " ").concat(ausNumber.slice(7));
    }
    if (ausNumber.match(_phoneNumberPattern.default.MOBILE)) {
      return "".concat(ausNumber.slice(0, 4), " ").concat(ausNumber.slice(4, 7), " ").concat(ausNumber.slice(7));
    }
    if (ausNumber.match(_phoneNumberPattern.default.LANDLINE_WITH_AREA)) {
      return "".concat(ausNumber.slice(0, 2), " ").concat(ausNumber.slice(2, 6), " ").concat(ausNumber.slice(6));
    }
    if (ausNumber.match(_phoneNumberPattern.default.LANDLINE_NO_AREA)) {
      return "".concat(ausNumber.slice(0, 4), " ").concat(ausNumber.slice(4));
    }
  }
  return phoneNumber;
}
var _default = exports.default = formatPhoneNumber;